import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class TabsService {

    private subject = new BehaviorSubject({});
    // private hasData = new BehaviorSubject({});

    sendActiveTab(tab: String) {
        this.subject.next({ 'activeTab': tab });
    }
    getActiveTab(): Observable<any> {
        return this.subject.asObservable();
    }
}
